import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Price } from '@grandvisionhq/common';
import { Hr, Heading, Text } from '@grandvisionhq/elements';
import { isDefined } from '@grandvisionhq/utils';
import { OrderDonationSummary } from '../OrderDonationSummary/OrderDonationSummary.js';

const TextElement = ({ children , isTotal  })=>isTotal ? /*#__PURE__*/ React.createElement(Heading, {
        component: "span",
        variant: "subheading1",
        className: "detail-footer__total-price"
    }, children) : /*#__PURE__*/ React.createElement(Text, {
        component: "span"
    }, children)
;
const Item = ({ label , className , children , isTotal  })=>/*#__PURE__*/ React.createElement("tr", {
        className: classnames('detail-footer__item', className)
    }, label && /*#__PURE__*/ React.createElement("th", {
        scope: "row"
    }, /*#__PURE__*/ React.createElement(TextElement, {
        isTotal: isTotal
    }, label)), children && /*#__PURE__*/ React.createElement("td", null, children))
;
const PriceItem = (_param)=> {
    var { price , label , currency , negativePrice , type ='default' , isTotal  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "price",
        "label",
        "currency",
        "negativePrice",
        "type",
        "isTotal"
    ]);
    return React.createElement(Item, swcHelpers.extends({
        label: label,
        isTotal: isTotal
    }, rest), /*#__PURE__*/ React.createElement(TextElement, {
        isTotal: isTotal
    }, /*#__PURE__*/ React.createElement(Price, {
        className: "detail-footer__price",
        value: negativePrice ? -price : price,
        currency: currency,
        type: type
    })));
};
const DetailFooter = ({ paymentMethod , subtotal , discount , shippingCost , total , currency , labels , donation ,  })=>{
    return /*#__PURE__*/ React.createElement("table", {
        className: "detail-footer"
    }, /*#__PURE__*/ React.createElement("tbody", null, paymentMethod && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Item, {
        label: labels.paymentMethod
    }, /*#__PURE__*/ React.createElement(TextElement, null, paymentMethod)), /*#__PURE__*/ React.createElement("td", {
        colSpan: 2
    }, /*#__PURE__*/ React.createElement(Hr, null))), isDefined(subtotal) && /*#__PURE__*/ React.createElement(PriceItem, {
        price: subtotal,
        label: labels.subtotal,
        currency: currency
    }), isDefined(discount) && discount > 0 && /*#__PURE__*/ React.createElement(PriceItem, {
        price: discount,
        negativePrice: true,
        type: "discount",
        label: labels.additionalDiscount,
        currency: currency
    }), isDefined(shippingCost) && shippingCost > 0 ? /*#__PURE__*/ React.createElement(PriceItem, {
        price: shippingCost,
        label: labels.shipping,
        currency: currency
    }) : /*#__PURE__*/ React.createElement(Item, {
        label: labels.shipping
    }, /*#__PURE__*/ React.createElement(TextElement, null, labels.free)), /*#__PURE__*/ React.createElement(PriceItem, {
        price: total,
        label: labels.total,
        currency: currency,
        isTotal: true
    }), donation && /*#__PURE__*/ React.createElement(OrderDonationSummary, {
        currency: currency,
        donationAmount: donation.amount,
        total: total,
        totalWithDonation: donation.totalWithDonation
    })));
};

export { DetailFooter as default };
//# sourceMappingURL=DetailFooter.js.map
